import styled from 'styled-components'

export const ContainerRadiology = styled.div`
  position: relative;
  flex: 1;
  height: 100%;
  padding: 40px 10px 10px;

  display: flex;
  flex-direction: column;
  gap: 1rem;
`
